<template>
  <div class="add-member">
    <van-search
      v-model="searchValue"
      placeholder="请输入用户邀请码/昵称"
      @search="onSearch"
       show-action
      input-align="center"
    >
      <template #action>
       <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <div class="tabs">
      <div 
        class="tabs-item" 
        :class="{'active': tabValue == tab.value}" 
        v-for="(tab, index) in tabs" 
        @click='changeTab(tab)'
        :key="index"
      >
        <div>{{tab.name}}</div>
      </div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check='true'
      @load="getList" 
      class="list"
    >
      <div class="item" v-for="(item, index) in list" :key="index">
        <img class="item-img" :src='item.avatarUrl'></img>
        <div class="item-right">
          <div style="display:flex" >
            <div>{{item.nickName}}</div>
            <div class="level" v-show='item.roleType == 1'>管理员</div>
          </div>
          <div class="c9 ft24" v-show='item.status == 1'>
            <div>已退出</div>
            <!-- <div class="c4" @click='openInvite'>重新邀请</div> -->
          </div>
          <!-- <div class="handle">
            <div class="handle-hover">
              <img class="handle-img" @click.stop='showSort(item, index)' src='https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/imgs/icons/omit.png'></img>
              <div class="handle-btn" v-show="item.handleFlag">
                <div class="handle-btn-1" @click='removePopup'>移除</div>
                <div class="handle-btn-1">设置群主</div>
                <div class="handle-btn-1 handle-btn-2">设置管理员</div> 
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </van-list>
    <!-- <div class="tac c6 ft28" v-if="!list.length && loading != 'loading'"  style="margin-top: 100px">暂无数据</div> -->
    <!-- <uni-popup ref="chat" type="dialog" style="zIndex: 101">
      <uni-popup-dialog 
        mode="base" 
        content='该用户已退出，是否邀请进群？' 
        type="warn" 
        :duration="2000" 
        :before-close="true" 
        @close="close" 
        @confirm="confirm"
        >
      </uni-popup-dialog>
    </uni-popup> -->
    <!-- <uni-popup ref="remove_popup" type="dialog" class="popop-handle" style="zIndex:101">
			<uni-popup-dialog 
        mode="base"
        content="是否移除?"
        type="warn"
        :duration="2000"
        :before-close="true"
				@close="closeRemove"
        @confirm="confirmRemove">
			</uni-popup-dialog>
		</uni-popup> -->
  </div>
</template>

<script>
import {getChatRoomMember} from '@/api/seller'
import { List, Search } from 'vant';
export default {
  data() {
    return {
      isShowDefault: true,
      searchValue: '',
      tabs: [
        {
          value: '',
          name: '全部'
        },
        {
          value: '0',
          name: '当前'
        },
        {
          value: '1',
          name: '已退'
        }
      ],
      tabValue: '',
       // 列表
      contentText: {
        contentdown: '',
        contentrefresh: '正在加载...',
        contentnomore: '没有更多数据了'
      },
      status:'more',
      pageSize: 10,
      pageNo: 1,
      list: [],
      chatRoomNo: '',
      loading: false,
      finished: false,
    }
  },
  mounted(opt) {
    const { query } = this.$route
    this.chatRoomNo = query.chatRoomNo
  },
  methods: {
    onSearch() {
      this.pageSize = 10
      this.pageNo = 1
      this.list = []
      this.loading = true
      this.finished = false
      this.getList()
    },
    cancelTtitle() {
      this.isShowDefault = true
      this.onSearch()
    },
    // 切换tab
    changeTab(item) {
      this.tabValue = item.value
      
      this.onSearch()
    },
    async getList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        condition: this.searchValue,
        chatRoomNo: this.chatRoomNo,
        status: this.tabValue
      }
			/** 如果是业务方 和系统方跳转 type参数 变成 对应角色 */
			this.status = 'loading' 
      // this.loading = false
			try {
				const res = await getChatRoomMember(params)
				this.loading = false
				/** 判断为空 */
				if (params.pageNo == 1 && (!res.ldata || !res.ldata.length)) {
					this.list = []
          this.finished = true
					this.status = 'empty'
					return
				}
        res.ldata.forEach(el => {
          el.handleFlag = false
        })
        this.pageNo++ 
				this.list = [...this.list, ...res.ldata]
        
				/** 判断是否已经加载完毕 */
				if (res.ldata.length < this.pageSize) {
				 this.finished = true
					return
				}
				this.status = 'more'
			} catch (error) {
				this.status = 'more'
			}
    },
    openInvite() {
      this.$refs.chat.open()
    },
    close() {
      this.$refs.chat.close()
    },
    confirm() {
      this.close()
    },
    // 移除
    closeRemove(){
      this.$refs.remove_popup.close()
    },
    // 确认
    confirmRemove(){
      this.closeRemove()
    },
    // 移除弹窗
    removePopup(index){
      
      this.$refs.remove_popup.open('center')
    },
    showSort(item, index) {
      this.list.forEach((el, i) => {
         el.handleFlag = false
      })
      item.handleFlag = true
      this.$forceUpdate()
    },
  },
  components: {
    'van-list': List,
    'vant-search': Search,
  }
}
</script>

<style scoped lang='less'>
.add-member {
  font-size: 28px;
  color: #222;
}
.tabs {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  &-item {
    margin-right: 20px;
    border-bottom: 2px solid transparent;
    &.active {
      color: #4777c3;
      border-bottom: 2px solid #4777c3;
    }
  }
}
.list {
  margin: 0 10px;
  .item {
    border: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    padding: 0 10px;
    height: 100px;
    width: 100%;
    border-radius: 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    &-img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin-right: 20px;
    }
    &-right {
      display: flex;
      justify-content: space-between;
      flex: 1;
      align-items: center;
    }
    .level {
      color: #fff;
      background: orange;
      font-size: 22px;
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
.c6 {
  color: #666;
}
.c9 {
  color: #999;
}
.tac {
  text-align: center;
}
.c4 {
  color: #4f51a6;
}
.ft24 {
  font-size: 24px;
}
.omit {
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.handle {
  display: flex;
  align-items: center;
  position: relative;
  &-img {
    width: 30px;
    height: 30px;
    margin-left: 10px;

  }
  .handle-hover {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-btn {
    // display: none;
    position: absolute;
    width: 80px;
    top: 60px;
    right: 0;
    background: rgba(0, 0, 0, .5);
    border-radius: 10px;
    text-align: center;
    color: #fff;
    font-size: 24px;
    padding: 0 10px;
    box-sizing: border-box;
    z-index: 1;
    &-1 {
      padding: 10px 0;
      border-bottom: 1px solid #fff;
    }
    &-2 {
      border: 0;
    }
  }
}

</style>
